import { Component, OnInit, Inject, Input, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MyteamsService } from '../_services/myteams.service';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
@Component({
  selector: 'app-multiswapplayers',
  templateUrl: './multiSwapPlayers.component.html',
  styleUrls: ['./multiSwapPlayers.component.scss']
})
export class MultiSwapPlayersComponent implements OnInit {
  isMobile = false;
  lgdata: any = [];
  curplayer: any = {};
  newplayer: any = {};
  leaguesList: any = {};
  otherLeagues =[];
  showLoader = false;
  allLeaguesChecked = false;
  indeterminate = false;
  user: any = {};
  playerURL = `${environment.assetURL}/assets/uploads/players/`;
  assetsURL = `${environment.assetURL}/assets/`;
  browsername='';
  isMac = false;

  @ViewChild('searchInput') searchElement: ElementRef;
  constructor(private store: Store<any>, public MyteamsService: MyteamsService, private spinner: NgxSpinnerService, private deviceService: DeviceDetectorService, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data, public dialogRef: MatDialogRef<MultiSwapPlayersComponent>) {
    if (navigator.appVersion.indexOf("Mac")!=-1) this.isMac =true;
    if (navigator.userAgent.match(/AppleWebKit/) && ! navigator.userAgent.match(/Chrome/)) {
      this.browsername = 'safaribrowser';
   }
    this.lgdata = data;
    this.curplayer = data.curplayer;
    this.newplayer = data.newplayer;
    if(this.lgdata.type=='mlinfo'){
      this.leaguesList = [];
      this.otherLeagues = data.leaguesList;
    }else{      
      this.leaguesList = data.leaguesList;
      this.otherLeagues = [];
    }

    this.isMobile = this.deviceService.isMobile();
    this.store.select('authData').subscribe(state => {
      if (state[0]) {
        this.user = state[0];
      }
    });
  }

  ngOnInit() {
  }

  ngOnChanges(e) {
    // need to detect input changes for user, parentPage
  }

  ngOnDestroy() {

  }
  checkAll(c) {
    this.allLeaguesChecked = c;
    this.leaguesList.forEach(t => (t.checked = c));
  }
  checkLeague(league, c) {
    league.checked = c;
    let checkedList = this.leaguesList.filter((t) => {
      return t.checked == true;
    });
    if (checkedList.length == this.leaguesList.length) {
      this.indeterminate = false;
      this.allLeaguesChecked = true;
    } else if (checkedList.length > 0) {
      this.allLeaguesChecked = false;
      this.indeterminate = true;
    } else {
      this.allLeaguesChecked = false;
      this.indeterminate = false;
    }
  }

  confirmMultiSwap() {
    let leagues = [];
    this.showLoader =true;
    this.leaguesList.forEach((t) => {
      if (t.checked == true) {
        leagues.push({ 'league_id': t.id, 'league_member_id': t.league_member_id });
      };
    });
    let swapQueueData = this.lgdata.swappedPlayers;
    let user_id = this.user.id;
    let postData = { 'swapQueueData': swapQueueData, 'user_id': user_id, 'leagues': leagues };
    this.MyteamsService.updateMultiSwapPlayer(postData).subscribe(res => {
      this.MyteamsService.getOtherLeaguesForMultiSwap(this.lgdata.multiSwap).subscribe(res => {
        this.showLoader =false;
        this.otherLeagues = res.entities;
        if(this.otherLeagues.length==0){
          this.dialogRef.close();
        }
      });
    });
  }
  getcheckedList(){
    let isChecked= false;
    this.leaguesList.forEach((t) => {
      if (t.checked == true) {
        isChecked = true;
      };
    });
    return isChecked;
  }
  skipSwap() {
    this.showLoader =true;
    this.MyteamsService.getOtherLeaguesForMultiSwap(this.lgdata.multiSwap).subscribe(res => {
      this.otherLeagues = res.entities;
      this.showLoader =false;
    });
  }
  goToLeague(league) {
    this.dialogRef.close(league);
  }
}